import React from 'react';
import ProjectBoxes from 'modules/dashboard/ProjectBoxes';

const DashboardPage = () => {
  return <ProjectBoxes />;
};

export default DashboardPage;
